import Button from "ds/components/Button";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import SplitControlButton from "ds/components/SplitControl/Button";
import SplitControlDropdown from "ds/components/SplitControl/Dropdown";
import SplitControlWrapper from "ds/components/SplitControl/Wrapper";
import { SlackEnvironment } from "types/generated";
import { isSelfHostedDistribution } from "utils/distribution";

import { openSetUpDrawer } from "./SetUp";
import useConnectSlackIntegration from "./useConnectSlackIntegration";

const isSelfHosted = isSelfHostedDistribution();

type SettingsIntegrationsSlackConnectButtonProps = {
  hasIntegration: boolean;
  hasAppConfig?: boolean;
  isGovSlackAvailable?: boolean;
};

const SettingsIntegrationsSlackConnectButton = ({
  hasIntegration,
  hasAppConfig,
  isGovSlackAvailable,
}: SettingsIntegrationsSlackConnectButtonProps) => {
  const { connectSlackIntegration, loading } = useConnectSlackIntegration();

  const handleSetUpSlackAppForSH = () => {
    openSetUpDrawer();
  };

  if (hasIntegration) return null;

  // On SaaS the commercial Slack app is always configured, on Self-Hosted it has to be set up first.
  const isCommercialAvailable = !isSelfHosted || !!hasAppConfig;

  if (isCommercialAvailable && isGovSlackAvailable) {
    return (
      <SplitControlWrapper variant="primary" size="medium">
        <SplitControlButton onPress={() => connectSlackIntegration()} loading={loading}>
          Connect
        </SplitControlButton>
        <SplitControlDropdown tooltip="Select Slack environment">
          <DropdownMenuItem onAction={() => connectSlackIntegration(SlackEnvironment.Commercial)}>
            Connect to Commercial Slack
          </DropdownMenuItem>
          <DropdownMenuItem onAction={() => connectSlackIntegration(SlackEnvironment.Govslack)}>
            Connect to GovSlack
          </DropdownMenuItem>
        </SplitControlDropdown>
      </SplitControlWrapper>
    );
  }

  // Self-Hosted with only GovSlack configured, keep the commercial app setup reachable.
  if (isGovSlackAvailable) {
    return (
      <SplitControlWrapper variant="primary" size="medium">
        <SplitControlButton
          onPress={() => connectSlackIntegration(SlackEnvironment.Govslack)}
          loading={loading}
        >
          Connect
        </SplitControlButton>
        <SplitControlDropdown tooltip="Select Slack environment">
          <DropdownMenuItem onAction={() => connectSlackIntegration(SlackEnvironment.Govslack)}>
            Connect to GovSlack
          </DropdownMenuItem>
          <DropdownMenuItem onAction={handleSetUpSlackAppForSH}>
            Set up Commercial Slack app
          </DropdownMenuItem>
        </SplitControlDropdown>
      </SplitControlWrapper>
    );
  }

  if (isCommercialAvailable) {
    return (
      <Button variant="primary" onPress={() => connectSlackIntegration()} loading={loading}>
        Connect
      </Button>
    );
  }

  return (
    <Button variant="primary" onPress={handleSetUpSlackAppForSH}>
      Set up
    </Button>
  );
};

export default SettingsIntegrationsSlackConnectButton;
